import { render, staticRenderFns } from "./GeneralStats.vue?vue&type=template&id=15132fbb&scoped=true"
import script from "./GeneralStats.vue?vue&type=script&lang=js"
export * from "./GeneralStats.vue?vue&type=script&lang=js"
import style0 from "./GeneralStats.vue?vue&type=style&index=0&id=15132fbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15132fbb",
  null
  
)

export default component.exports